@if (option) {
  <odx-content-box
    class="content-box flex-column"
    [ngClass]="{
      selected: selected,
      selectable: selectionMode,
    }"
    odxLayout="flex gap-none"
  >
    <odx-area-header class="header">
      <h6 class="odx-heading-5 card-title">
        {{ option.displayName }}
      </h6>
      @if (isGroup) {
        <odx-action-group class="group-menu">
          <button
            odxButton
            class="group-menu-button"
            [odxMenu]="groupMenu"
            odxMenuPosition="bottom-end"
            (click)="$event.stopPropagation()"
          >
            <odx-icon name="more" size="medium" aria-hidden="true"></odx-icon>
          </button>
        </odx-action-group>
      }
    </odx-area-header>

    <div class="h-100 content">
      <div class="image-wrapper">
        <app-standard-image [imageUrl]="option.imageId"></app-standard-image>
      </div>

      @if (option.description || (option.matNr && option.option.devices.length === 1)) {
        <div class="content-details">
          @if (option.description) {
            <div class="feature">
              <p class="p-label odx-text--small" i18n="@@monitoringConfiguration.description">Description</p>
              <p class="odx-text--small">{{ option.description }}</p>
            </div>
          }

          @if (option.matNr && option.option.devices.length === 1) {
            <div class="feature">
              <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
              <p class="odx-text--small">{{ option.matNr }}</p>
            </div>
          }
        </div>
      }

      @if (option.configurationURL) {
        <div class="link-row" odxLayout="flex">
          <a
            odxLink
            class="card-link"
            [href]="option.configurationURL"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()"
          >
            <odx-icon name="document" inline></odx-icon>
            <span i18n="@@global.productDatasheet">Produktdatenblatt</span>
          </a>
        </div>
      }

      @if (option.piSheetURL) {
        <div class="link-row" odxLayout="flex">
          <a
            odxLink
            class="card-link"
            [href]="option.piSheetURL"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()"
          >
            <odx-icon name="document" inline></odx-icon>
            <span i18n="@@monitoringConfiguration.optionCard.piSheetURL">Produktinformationsblatt</span>
          </a>
        </div>
      }
    </div>

    <odx-content-box-footer class="footer w-100">
      <div odxLayout="flex" class="space-between">
        <!-- do not propagate radio button click to prevent from multiple click events when card is clicked -->
        @if (selectionMode === StepSelectionType.PICK1 || selectionMode === StepSelectionType.PICK0TO1) {
          <odx-radio-button (click)="$event.stopPropagation()" [value]="option" i18n="@@global.select"
            >Auswählen</odx-radio-button
          >
        }
      </div>
    </odx-content-box-footer>
  </odx-content-box>
}

<ng-template #groupMenu>
  <odx-menu>
    <button odxButton odxMenuItem (click)="$event.stopPropagation(); showGroupDetails()">
      <odx-icon name="document" alignLeft></odx-icon>
      <span i18n="@@monitoring.groupedParts.menu.showComponents">Komponenten anzeigen</span>
    </button>
  </odx-menu>
</ng-template>
